
  import React from 'react';
  import COMPONENTS from '../../components';
  import { get } from 'lodash';
  import PageLayout from '../../layout';
  import { graphql } from 'gatsby';

  class Page extends React.Component {
    state = {
      data: [],
    };

    componentDidMount() {
      let slices;

      const data = get(this, 'props.data.foundersJson');

      if (data) {
        slices = Object.entries(data).map(([key, content]) => ({
          componentName: key,
          ...content,
        }));

        slices.sort(
          ({ position: positionA }, { position: positionB }) =>
            positionA - positionB
        );

        this.setState({
          data: slices,
        });
      }
    }

    render() {
      return (
        <PageLayout>
          {get(this, 'state.data').map(({ componentName, data }, index) => {
            const ComponentType = COMPONENTS[componentName];
            return <ComponentType key={index} {...data} />;
          })}
        </PageLayout>
      );
    }
  }

  export default Page;

  export const pageQuery = graphql`
    query {
      foundersJson {
        
      
      
      
      
      
      
      
      
      
      
      CTAWith2Buttons0 {
        position
        componentName
        data {
           title description buttonDark {  text link } buttonLight {  text link }
        }
      }
    
      BannerMask1 {
        position
        componentName
        data {
           media {  type src } corners height
        }
      }
    
      TableRow2 {
        position
        componentName
        data {
           content {  title textBody }
        }
      }
    
      CTA3 {
        position
        componentName
        data {
           title textBody button {  text link }
        }
      }
    
      ProductSingle4 {
        position
        componentName
        data {
           title textBody image background imageSide
        }
      }
    
      Block3Column5 {
        position
        componentName
        data {
           background content {  title textBody link {  linkUrl } }
        }
      }
    
      SlideshowProfile6 {
        position
        componentName
        data {
           slides {  image title textBody }
        }
      }
    
      LogoRoll7 {
        position
        componentName
        data {
           header iconGroup {  social logoUrl }
        }
      }
    
      Divider8 {
        position
        componentName
        data {
           height
        }
      }
    
      CTAColumn9 {
        position
        componentName
        data {
           title type description button {  text link }
        }
      }
    
      }
    }
  `